import { ADD_TOAST, REMOVE_TOAST } from "../actions/toastActions"

// Slice "toasts" : file de notifications (danger/warning/success/info).
// Convention : slice *Reducer = repensée.
const initialState = { items: [] }

export default function toastReducer(state = initialState, action) {
	switch (action.type) {
		case ADD_TOAST:
			// Dédup : pas deux toasts identiques empilés à l'écran.
			if (
				state.items.some(
					(t) =>
						t.level === action.toast.level &&
						t.message === action.toast.message,
				)
			) {
				return state
			}
			return { ...state, items: [...state.items, action.toast] }
		case REMOVE_TOAST:
			return {
				...state,
				items: state.items.filter((t) => t.id !== action.id),
			}
		default:
			return state
	}
}
